import React from "react";
import { useTCSData } from "../../../context/TcsContext";
import Button from 'react-bootstrap/Button';
import TeacherList from "./TeacherList";
import ScheduleMatrix from "./Matrix";


const Timetable = () => {

  const { subjectAssignment, loadingSD, refetchSCData } = useTCSData();
  
  // let teachersArray = [];
  // if( scheduledData.length > 0){
  //   teachersArray = scheduledData.map(item => {
  //     return item.teacher;
  //   })
  // }

  // console.log(subjectAssignment);

  return (
    <>
      <div className="row">
          <div className="col-xl-12">
              <div className="page-title flex-wrap">       
                    {/* <TeacherList /> */}
              </div>
          </div>                           
          <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
              <div className="table-responsive full-data pb-20">
                  <ScheduleMatrix subjectAssignment={subjectAssignment} />
              </div> 
          </div> 
      </div> 
    </>
  )
}

export default Timetable
